import React, { useCallback } from 'react'
import isProd from '../../../utils/constants/isProd'
import { useDispatch } from 'react-redux'
import { setPartInBasketQuantity, setParts } from '../../table/partsInBasketSlice'
import axios from 'axios'

const ButtonBuyQuantityEmex = ({ part, basketInfo, showQuantitySelect = true }) => {
    const dispatch = useDispatch()
    const maxQuantity = part.quantity
    const basketQuantity = basketInfo['quantity']
    const basketID = basketInfo['basket_id']

    const setBasketQuantity = useCallback(
        (basketQuantity) => {
            if (isProd) {
                const sessid = window.BX.bitrix_sessid()
                const ajaxUpdateBasketQuantityUrl =
                    '/bitrix/templates/autoparts/components/linemedia.auto/store.sale.basket.basket/store.sale.basket.basket/ajax_component.php'

                const data = new URLSearchParams()
                data.append('BASKET_ID', basketID)
                data.append('QUANTITY', basketQuantity)
                data.append('sessid', sessid)

                const basketQuantityUrl =
                    '/ajax/basket-parts.php?sessid=' + window.BX.bitrix_sessid()
                const basketHeaderUrl = '/ajax/basket_header.php'
                const basketHeaderClass = 'b-top-basket'

                axios
                    .post(ajaxUpdateBasketQuantityUrl, data)
                    .then(() => fetch(basketHeaderUrl))
                    .then((res) => res.text())
                    .then((html) => {
                        document.getElementsByClassName(basketHeaderClass)[0].innerHTML = html
                    })
                    .then(() => fetch(basketQuantityUrl))
                    .then((res) => res.json())
                    .then(
                        (result) => {
                            if (result.result) {
                                dispatch(setParts(result.data))
                            } else {
                                console.log('Ajax error (buyAction) : ' + result.error)
                            }
                        },
                        (error) => {
                            console.log('Ajax error (buyAction) : ' + error)
                        }
                    )
            } else {
                dispatch(
                    setPartInBasketQuantity({ hash: part.basket_hash, quantity: basketQuantity })
                )
            }
        },
        [basketID, part, dispatch]
    )

    const onChange = (e) => {
        let quantity = Number(e.target.value)

        if (quantity <= 0) {
            quantity = 0
        }

        if (quantity > maxQuantity) {
            quantity = maxQuantity
        }

        setBasketQuantity(quantity)
    }
    const increaseBasketQuantity = (e) => {
        setBasketQuantity(basketQuantity < maxQuantity ? basketQuantity + 1 : maxQuantity)
    }
    const decreaseBasketQuantity = (e) => {
        setBasketQuantity(basketQuantity === 1 ? 0 : basketQuantity - 1)
    }

    return (
        <div className="buying">
            <div className="buying__quantity in_basket">
                <button className="buying__quantity-dec" onClick={decreaseBasketQuantity}>
                    -
                </button>
                <input
                    className="buying__quantity-input"
                    onChange={onChange}
                    type="text"
                    value={basketQuantity}
                />
                <button className="buying__quantity-inc" onClick={increaseBasketQuantity}>
                    +
                </button>
                <span className="button-buy__count">{basketQuantity}</span>
            </div>
        </div>
    )
}

export default ButtonBuyQuantityEmex
